import { createStore } from 'vuex'

import { account } from './account.module'
import { alert } from './alert.module'
import { labels } from './labels.module'
import { auth0 } from './auth0.module'

const store = createStore({
  modules: {
    account,
    alert,
    labels,
    auth0
  }
})

export default store
